import { useEffect, useState } from 'react';

interface BackendVersion {
  version: string;
  env: string;
  git_sha?: string;
}

/**
 * 讀取後端 /version 的版本資訊
 *
 * - 成功時回傳 version / env / git_sha
 * - 失敗時會 fallback 到 import.meta.env.VITE_APP_VERSION 或 'dev'
 */
export function useBackendVersion() {
  const [data, setData] = useState<BackendVersion | null>(null);

  useEffect(() => {
    let isMounted = true;

    const fetchVersion = async () => {
      try {
        const apiBase =
          import.meta.env.VITE_API_BASE_URL ?? window.location.origin;
        const response = await fetch(`${apiBase.replace(/\/$/, '')}/version`);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const json = (await response.json()) as BackendVersion;

        if (!isMounted) return;

        setData({
          version: json.version,
          env: json.env,
          git_sha: json.git_sha,
        });
      } catch {
        if (!isMounted) return;
        const fallbackVersion = import.meta.env.VITE_APP_VERSION ?? 'dev';
        setData({
          version: fallbackVersion,
          env: 'unknown',
        });
      }
    };

    void fetchVersion();

    return () => {
      isMounted = false;
    };
  }, []);

  return data;
}
